import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useBookingContext } from '../../../contexts/BookingProvider';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AssociateCard from '../../CommonComps/Cards/AssociateCard';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import SectionHeader from '../../CommonComps/Titles/SectionHeader';
import BookingSuggestionAction from './BookingSuggestionAction';

const AppointmentSearchResults = () => {
  // integration of context API hooks here
  const { isLoading, isFetched, availableAssociates } = useBookingContext();

  // rendering appointment search results section component here
  return (
    <>
      {isLoading ? (
        <AcademiaLoading />
      ) : isFetched ? (
        <motion.section
          variants={sectionAnimVariants}
          initial='initial'
          animate='animate'
        >
          <SectionHeader
            headerText='Search Results'
            extraElement={<BookingSuggestionAction />}
          />

          {availableAssociates.length ? (
            <div className='grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5'>
              {availableAssociates.map((associate) => (
                <AssociateCard key={associate.id} associate={associate} />
              ))}
            </div>
          ) : (
            <AcademiaNotFound message='No Associate found!!' />
          )}
        </motion.section>
      ) : null}
    </>
  );
};

export default AppointmentSearchResults;
